export default __webpack_public_path__ + "static/media/AnjaleeGunathunga.59082b23.jpeg";